const map = {
    /**
     * Element
     */
    map: null,

    /**
     * Component Options
     */
    options: {
        center: null,
        zoom: 14,
        disableDefaultUI: true,
        styles: [
            {
                featureType: "poi",
                elementType: "labels",
                stylers: [{ visibility: "off" }],
            },
        ],
    },

    /**
     * Component Marker
     */
    marker: null,

    /**
     * Address Keys
     */
    addressKeys: {
        route: "address",
        transit_station: "address",
        street_number: "address_number",
        locality: "address_province",
        administrative_area_level_2: "address_city",
        postal_code: "address_postcode",
    },

    /**
     * Init Component
     */
    init() {
        const input = document.getElementById("map-input");

        if (!input) {
            return;
        }

        this.options.center = new google.maps.LatLng(
            40.417663914033504,
            -3.7031504553820502
        );

        if (document.body.contains(input) && input.value) {
            const coordinates = input.value.split(",");
            this.options.center = new google.maps.LatLng(
                coordinates[0],
                coordinates[1]
            );

            this.options.zoom =
                parseInt(localStorage.getItem("google-maps-zoom")) || 12;
        } else {
            console.log('Error 67');
        }

        const map = document.getElementById("map");
        if (document.body.contains(map)) {
            map.style.height = "500px";
            this.map = new google.maps.Map(map, this.options);
            this.map.addListener("zoom_changed", () =>
                localStorage.setItem("google-maps-zoom", this.map.getZoom())
            );
            this.marker();
            this.autocomplete();
        } else {
            console.log('Error 81');
        }
    },

    /**
     * Component Marker
     */
    marker() {
        this.marker = new google.maps.Marker({
            position: this.options.center,
            title: "Foodcoin!",
            draggable: !document.getElementById("map-input").disabled,
        });

        const icon = {
            url: "/images/marker.png",
            scaledSize: new google.maps.Size(60, 73),
        };

        this.marker.setIcon(icon);
        this.marker.addListener("dragend", () => this.position());
        this.marker.setMap(this.map);
    },

    /**
     * Get position of Marker
     */
    position() {
        const location = [
            this.marker.getPosition().lat(),
            this.marker.getPosition().lng(),
        ];

        document.getElementById("map-input").value = location.join(",");
    },

    /**
     *
     */
    geo(location) {

        const geocoder = new google.maps.Geocoder();
        const params = { location: { lat: location[0], lng: location[1] } };
        geocoder.geocode(params, (r, s) => this.address(r, s));
    },

    /**
     *
     */
    autocomplete() {
        const input = document.getElementById("pac-input");

        if (!input) {
            return;
        }

        const autocomplete = new google.maps.places.Autocomplete(
            input,
            this.options
        );

        google.maps.event.addListener(autocomplete, "place_changed", () => {
            this.marker.setVisible(false);
            var place = autocomplete.getPlace();
            if (!place.geometry) {
                return;
            }

            if (place.geometry.viewport) {
                this.map.fitBounds(place.geometry.viewport);
            } else {
                this.map.setCenter(place.geometry.location);
                this.map.setZoom(17); // Why 17? Because it looks good.
            }

            this.marker.setPosition(place.geometry.location);
            this.marker.setVisible(true);
            this.address(place.address_components);
            this.position();
        });
    },

    /**
     *
     * @param {*} results
     * @param {*} status
     */
    address(address) {
        address.forEach((item) => {
            item.types.forEach((type) => {
                if (type in this.addressKeys) {
                    document.getElementsByName(
                        this.addressKeys[type]
                    )[0].value = item.long_name;
                }
            });
        });
    },
};

map.init();
